import FormProStyle from "../templates/Form.style";
import FormHzeroStyle from "../templates-hzero/Form.style";
var formData = {
  name: 'form',
  data: [{
    floatInputHeight: 32,
    floatTextHeight: 20
  }],
  onlyTemplate: {
    pro: FormProStyle,
    hzero: FormHzeroStyle
  }
};
export default formData;